import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import RefreshIcon from "@mui/icons-material/Refresh";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import Grid from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import Drawflow from "drawflow";
import { useState } from "react";

import MDBox from "@/components/atoms/MDBox";

type ActionButtonsComponentProps = React.ComponentPropsWithoutRef<typeof MDBox> & {
  editorRef: React.MutableRefObject<Drawflow | null>;
};

export default function ActionButtonsComponent({
  editorRef,
  ...rest
}: ActionButtonsComponentProps) {
  const [isLocked, setIsLocked] = useState(false);

  const handleZoomIn = () => {
    editorRef.current?.zoom_in();
  };

  const handleZoomOut = () => {
    editorRef.current?.zoom_out();
  };

  const handleZoomReset = () => {
    editorRef.current?.zoom_reset();
  };

  const handleLock = () => {
    if (editorRef.current) {
      const newMode = editorRef.current.editor_mode === "fixed" ? "edit" : "fixed";
      editorRef.current.editor_mode = newMode;
      setIsLocked(newMode === "fixed");
    }
  };

  return (
    <MDBox {...rest}>
      <Grid container>
        <Grid size={3}>
          <IconButton onClick={handleZoomIn} aria-label="zoom in">
            <ZoomInIcon sx={{ color: "white !important", fontSize: 25 }} />
          </IconButton>
        </Grid>
        <Grid size={3}>
          <IconButton onClick={handleZoomOut} aria-label="zoom out">
            <ZoomOutIcon sx={{ color: "white !important", fontSize: 25 }} />
          </IconButton>
        </Grid>
        <Grid size={3}>
          <IconButton onClick={handleZoomReset} aria-label="reset zoom">
            <RefreshIcon sx={{ color: "white !important", fontSize: 25 }} />
          </IconButton>
        </Grid>
        <Grid size={3}>
          <IconButton onClick={handleLock} aria-label={isLocked ? "unlock" : "lock"}>
            {isLocked ? (
              <LockIcon sx={{ color: "white !important", fontSize: 25 }} />
            ) : (
              <LockOpenIcon sx={{ color: "white !important", fontSize: 25 }} />
            )}
          </IconButton>
        </Grid>
      </Grid>
    </MDBox>
  );
}
